import { render, staticRenderFns } from "./Query.vue?vue&type=template&id=0df3d7af&scoped=true&"
import script from "./Query.vue?vue&type=script&lang=js&"
export * from "./Query.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df3d7af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0df3d7af', component.options)
    } else {
      api.reload('0df3d7af', component.options)
    }
    module.hot.accept("./Query.vue?vue&type=template&id=0df3d7af&scoped=true&", function () {
      api.rerender('0df3d7af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/insights/Query.vue"
export default component.exports